const exportedObject = {
  obtenerDatosPssData: {},
  obtenerDatosPssLoading: false,
  obtenerDatosPssError: null,

  obtenerCoberturaContratadaPssData: {
    coberturas: [],
    totalRegistros: 0,
    numeroPagina: 1,
    tamanoPagina: 20,
    totalPaginas: 1
  },
  obtenerCoberturaContratadaPssLoading: false,
  obtenerCoberturaContratadaPssError: null,

  guardarCoberturaContratadaPssData: [],
  guardarCoberturaContratadaPssLoading: false,
  guardarCoberturaContratadaPssError: null,

  obtenerTipoCoberturasData: [],
  obtenerTipoCoberturasLoading: false,
  obtenerTipoCoberturasError: null,

  obtenerCoberturasData: undefined,
  obtenerCoberturasLoading: false,
  obtenerCoberturasError: null,

  obtenerCoberturaDocumentosData: [],
  obtenerCoberturaDocumentosLoading: false,
  obtenerCoberturaDocumentosError: null,

  guardarCoberturaDocumentosData: [],
  guardarCoberturaDocumentosLoading: false,
  guardarCoberturaDocumentosError: null,

  obtenerCoberturasConfiguradasPssData: undefined,
  obtenerCoberturasConfiguradasPssLoading: false,
  obtenerCoberturasConfiguradasPssError: null,

  obtenerCoberturasConfiguradasDocumentosData: undefined,
  obtenerCoberturasConfiguradasDocumentosLoading: false,
  obtenerCoberturasConfiguradasDocumentosError: null
};

export default exportedObject;
